module.exports = __webpack_public_path__ + "static/media/Triclorotableta-02.77764a41.jpg";